module.exports = __webpack_public_path__ + "static/media/directory-default.29454f9c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/icons/directory-default.svg
// module id = 1629
// module chunks = 2